import * as processesAbbreviations from 'modules/Abbreviations/processes';
import { selectAbbreviationsData } from 'modules/Abbreviations/store/selectors';
import { call, select } from 'redux-saga/effects';
import * as Models from 'models';
import * as processes from 'services/processes';
import { sagaFlow } from 'utils/sagaFlow';
import { getProjectAssets } from './getProjectAssets';

export function* processRefreshedAssets(
  refreshedData: Models.RefreshResponseData,
  isProjectTranslatable: boolean,
  projectAssets?: Models.ProjectAssetsToUpload,
): Generator<unknown, Models.RefreshProcessArgs> {
  const projectPrevAssets =
    projectAssets ??
    (yield call(getProjectAssets, { removeInternalInfo: false })) as ReturnTypeSaga<typeof getProjectAssets> as Models.ProjectAssetsToUpload;

  const prevAssets: Models.RefreshProcessArgs['prevAssets'] = {
    documents: projectPrevAssets.documents,
  };

  const textAbbreviationDocuments: ReturnTypeSaga<typeof selectAbbreviationsData> = yield select(selectAbbreviationsData);
  const textAbbreviationDocumentsArray = textAbbreviationDocuments.toJS() as Models.TextAbbreviationDocumentsArray;

  const assets: Models.RefreshProcessArgs['assets'] = {
    ...projectPrevAssets,
    documents: refreshedData.documents,
    rootDocument: refreshedData.rootDocument,
    masterScreenData: refreshedData.masterScreenData,
  };

  const dataToProcess: Models.RefreshProcessArgs = {
    assets,
    prevAssets,
    notificationOptions: [],
    actionsWithMiddleware: [],
    newDocumentsQuantity: null,
    documentStatusMap: refreshedData.documentStatusMap,
    isProjectTranslatable,
  };

  const refreshedDataProcesses = sagaFlow<Models.RefreshProcessArgs>(
    processes.getNewDocumentsQuantity,
    processes.resetRelationsWithoutDocument,
    processes.removeUnusedReferences,
    processes.processBrandDefinition,
    processes.processScreenDefinitions,
    processes.validateSSIElements,
    processes.normalizeLayeredDocuments,
    processes.extendReusableLayoutBrandDefinitions,
    data => processes.refreshLayoutsOnArtboards(data, false),
    processes.resetLayoutsWithoutDocument,
    processes.processBackgroundImages,
    processes.getActionsToStoryCardThumbnailsLoading,
    processes.getActionsToLayoutPreviewsLoading,
    processes.getActionsToImagesLoading,
    processes.updateExistingProjectMetadataTokens,
    (arg) => {
      const { documents } = arg.assets;
      arg.assets.documents = processesAbbreviations.removeMissingAbbreviations(documents, textAbbreviationDocumentsArray);

      return arg;
    },
  );

  const processedData: ReturnTypeSaga<typeof refreshedDataProcesses> = yield call(refreshedDataProcesses, dataToProcess);

  return processedData;
}
